import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { BuyPage } from 'Views/BuyPage';
import FreemiumEntry from 'Views/FreemiumEntry';
import NotBuyPage from './NotBuyPage';
import paths from '../../../../../paths';

const HasHomeResource = () => {
  return (
    <Switch>
      {/* Routes */}
      <Route path={paths.freemium} component={FreemiumEntry} />
      <Route path={paths.buy} component={BuyPage} />
      <Route component={NotBuyPage} />
    </Switch>
  );
};

export default HasHomeResource;
